import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=0e2797e4&scoped=true&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProjectList.vue?vue&type=style&index=1&id=0e2797e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2797e4",
  null
  
)

export default component.exports